import type { FC, ReactElement, ReactNode } from 'react';
import React from 'react';
import {
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material';

import ModalCloseHeader from 'src/components/common/Modal/ModalCloseHeader';

import { styles } from './index.styles';

export const MODAL_TEST_ID = 'modal';
export const MODAL_CONTENT_TEST_ID = 'modal-content';
export const MODAL_CLOSE_BUTTON_TEST_ID = 'close-modal-button';

export interface ModalProps {
  children?: ReactNode;
  className?: string;
  closeIconHidden?: boolean;
  headline?: string | ReactNode;
  icon?: ReactElement;
  isOpen: boolean;
  message?: string;
  noWrapperMargin?: boolean;
  onClose: (x?: boolean) => void;
}

const Modal: FC<ModalProps> = ({
  children,
  className,
  closeIconHidden,
  headline,
  icon,
  isOpen,
  message,
  noWrapperMargin,
  onClose,
}) => {
  const onBackdropClick = (event: object, reason: string) => {
    if (isOpen && (reason === 'backdropClick' || reason === 'escapeKeyDown'))
      onClose(true);
  };

  return (
    <Dialog
      open={isOpen}
      sx={styles.modal}
      data-test-id={MODAL_TEST_ID}
      onClose={onBackdropClick}
    >
      {!closeIconHidden && <ModalCloseHeader onClose={() => onClose(false)} />}

      <DialogTitle component="div">
        <Box sx={styles.headlineWrapper}>
          {!!icon && <Box sx={styles.headlineIcon}>{icon}</Box>}
          {!!headline && <Typography variant="h4">{headline}</Typography>}
        </Box>
        {!!message && <Typography variant="h6">{message}</Typography>}
      </DialogTitle>

      <DialogContent
        className={className}
        data-test-id={MODAL_CONTENT_TEST_ID}
        id={'modal-dialog-content'}
      >
        {!!children && (
          <Box
            sx={[
              styles.contentWrapper,
              ...(noWrapperMargin ? [styles.contentWrapperNoMargin] : []),
            ]}
          >
            {children}
          </Box>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default Modal;
